/**
 * Pinned first in {@link COUNTRIES} and used as the default pre-selected value in country
 * selectors (e.g. organization creation) — most of the user base is Japanese (issue #202).
 */
export const DEFAULT_COUNTRY_CODE = 'JP'

export const COUNTRIES: { code: string; name: string }[] = [
  { code: 'JP', name: 'Japan' },
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'CV', name: 'Cabo Verde' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CF', name: 'Central African Republic' },
  { code: 'TD', name: 'Chad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comoros' },
  { code: 'CG', name: 'Congo' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Greece' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: 'Laos' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libya' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshall Islands' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MX', name: 'Mexico' },
  { code: 'FM', name: 'Micronesia' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'KP', name: 'North Korea' },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russia' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'KN', name: 'Saint Kitts and Nevis' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'São Tomé and Príncipe' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'KR', name: 'South Korea' },
  { code: 'SS', name: 'South Sudan' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syria' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
]

const COUNTRY_MAP = new Map(COUNTRIES.map((c) => [c.code, c.name]))

// ── Country → default timezone ────────────────────────────────────────────────

/**
 * One representative IANA timezone per {@link COUNTRIES} code, used to preselect the
 * event editor's timezone from the organization's registered country (issue: organizers
 * were confused by a bare timezone dropdown with no sensible default). For countries
 * spanning multiple zones, the capital's or most-populous city's zone is used — an
 * organizer whose event is actually in a different zone can still change it explicitly.
 */
export const COUNTRY_TIMEZONES: Record<string, string> = {
  JP: 'Asia/Tokyo',
  AF: 'Asia/Kabul',
  AL: 'Europe/Tirane',
  DZ: 'Africa/Algiers',
  AD: 'Europe/Andorra',
  AO: 'Africa/Luanda',
  AG: 'America/Antigua',
  AR: 'America/Argentina/Buenos_Aires',
  AM: 'Asia/Yerevan',
  AU: 'Australia/Sydney',
  AT: 'Europe/Vienna',
  AZ: 'Asia/Baku',
  BS: 'America/Nassau',
  BH: 'Asia/Bahrain',
  BD: 'Asia/Dhaka',
  BB: 'America/Barbados',
  BY: 'Europe/Minsk',
  BE: 'Europe/Brussels',
  BZ: 'America/Belize',
  BJ: 'Africa/Porto-Novo',
  BT: 'Asia/Thimphu',
  BO: 'America/La_Paz',
  BA: 'Europe/Sarajevo',
  BW: 'Africa/Gaborone',
  BR: 'America/Sao_Paulo',
  BN: 'Asia/Brunei',
  BG: 'Europe/Sofia',
  BF: 'Africa/Ouagadougou',
  BI: 'Africa/Bujumbura',
  CV: 'Atlantic/Cape_Verde',
  KH: 'Asia/Phnom_Penh',
  CM: 'Africa/Douala',
  CA: 'America/Toronto',
  CF: 'Africa/Bangui',
  TD: 'Africa/Ndjamena',
  CL: 'America/Santiago',
  CN: 'Asia/Shanghai',
  CO: 'America/Bogota',
  KM: 'Indian/Comoro',
  CG: 'Africa/Brazzaville',
  CR: 'America/Costa_Rica',
  HR: 'Europe/Zagreb',
  CU: 'America/Havana',
  CY: 'Asia/Nicosia',
  CZ: 'Europe/Prague',
  DK: 'Europe/Copenhagen',
  DJ: 'Africa/Djibouti',
  DM: 'America/Dominica',
  DO: 'America/Santo_Domingo',
  EC: 'America/Guayaquil',
  EG: 'Africa/Cairo',
  SV: 'America/El_Salvador',
  GQ: 'Africa/Malabo',
  ER: 'Africa/Asmara',
  EE: 'Europe/Tallinn',
  SZ: 'Africa/Mbabane',
  ET: 'Africa/Addis_Ababa',
  FJ: 'Pacific/Fiji',
  FI: 'Europe/Helsinki',
  FR: 'Europe/Paris',
  GA: 'Africa/Libreville',
  GM: 'Africa/Banjul',
  GE: 'Asia/Tbilisi',
  DE: 'Europe/Berlin',
  GH: 'Africa/Accra',
  GR: 'Europe/Athens',
  GD: 'America/Grenada',
  GT: 'America/Guatemala',
  GN: 'Africa/Conakry',
  GW: 'Africa/Bissau',
  GY: 'America/Guyana',
  HT: 'America/Port-au-Prince',
  HN: 'America/Tegucigalpa',
  HU: 'Europe/Budapest',
  IS: 'Atlantic/Reykjavik',
  IN: 'Asia/Kolkata',
  ID: 'Asia/Jakarta',
  IR: 'Asia/Tehran',
  IQ: 'Asia/Baghdad',
  IE: 'Europe/Dublin',
  IL: 'Asia/Jerusalem',
  IT: 'Europe/Rome',
  JM: 'America/Jamaica',
  JO: 'Asia/Amman',
  KZ: 'Asia/Almaty',
  KE: 'Africa/Nairobi',
  KI: 'Pacific/Tarawa',
  KW: 'Asia/Kuwait',
  KG: 'Asia/Bishkek',
  LA: 'Asia/Vientiane',
  LV: 'Europe/Riga',
  LB: 'Asia/Beirut',
  LS: 'Africa/Maseru',
  LR: 'Africa/Monrovia',
  LY: 'Africa/Tripoli',
  LI: 'Europe/Vaduz',
  LT: 'Europe/Vilnius',
  LU: 'Europe/Luxembourg',
  MG: 'Indian/Antananarivo',
  MW: 'Africa/Blantyre',
  MY: 'Asia/Kuala_Lumpur',
  MV: 'Indian/Maldives',
  ML: 'Africa/Bamako',
  MT: 'Europe/Malta',
  MH: 'Pacific/Majuro',
  MR: 'Africa/Nouakchott',
  MU: 'Indian/Mauritius',
  MX: 'America/Mexico_City',
  FM: 'Pacific/Chuuk',
  MD: 'Europe/Chisinau',
  MC: 'Europe/Monaco',
  MN: 'Asia/Ulaanbaatar',
  ME: 'Europe/Podgorica',
  MA: 'Africa/Casablanca',
  MZ: 'Africa/Maputo',
  MM: 'Asia/Yangon',
  NA: 'Africa/Windhoek',
  NR: 'Pacific/Nauru',
  NP: 'Asia/Kathmandu',
  NL: 'Europe/Amsterdam',
  NZ: 'Pacific/Auckland',
  NI: 'America/Managua',
  NE: 'Africa/Niamey',
  NG: 'Africa/Lagos',
  KP: 'Asia/Pyongyang',
  MK: 'Europe/Skopje',
  NO: 'Europe/Oslo',
  OM: 'Asia/Muscat',
  PK: 'Asia/Karachi',
  PW: 'Pacific/Palau',
  PA: 'America/Panama',
  PG: 'Pacific/Port_Moresby',
  PY: 'America/Asuncion',
  PE: 'America/Lima',
  PH: 'Asia/Manila',
  PL: 'Europe/Warsaw',
  PT: 'Europe/Lisbon',
  QA: 'Asia/Qatar',
  RO: 'Europe/Bucharest',
  RU: 'Europe/Moscow',
  RW: 'Africa/Kigali',
  KN: 'America/St_Kitts',
  LC: 'America/St_Lucia',
  VC: 'America/St_Vincent',
  WS: 'Pacific/Apia',
  SM: 'Europe/San_Marino',
  ST: 'Africa/Sao_Tome',
  SA: 'Asia/Riyadh',
  SN: 'Africa/Dakar',
  RS: 'Europe/Belgrade',
  SC: 'Indian/Mahe',
  SL: 'Africa/Freetown',
  SG: 'Asia/Singapore',
  SK: 'Europe/Bratislava',
  SI: 'Europe/Ljubljana',
  SB: 'Pacific/Guadalcanal',
  SO: 'Africa/Mogadishu',
  ZA: 'Africa/Johannesburg',
  KR: 'Asia/Seoul',
  SS: 'Africa/Juba',
  ES: 'Europe/Madrid',
  LK: 'Asia/Colombo',
  SD: 'Africa/Khartoum',
  SR: 'America/Paramaribo',
  SE: 'Europe/Stockholm',
  CH: 'Europe/Zurich',
  SY: 'Asia/Damascus',
  TW: 'Asia/Taipei',
  TJ: 'Asia/Dushanbe',
  TZ: 'Africa/Dar_es_Salaam',
  TH: 'Asia/Bangkok',
  TL: 'Asia/Dili',
  TG: 'Africa/Lome',
  TO: 'Pacific/Tongatapu',
  TT: 'America/Port_of_Spain',
  TN: 'Africa/Tunis',
  TR: 'Europe/Istanbul',
  TM: 'Asia/Ashgabat',
  TV: 'Pacific/Funafuti',
  UG: 'Africa/Kampala',
  UA: 'Europe/Kyiv',
  AE: 'Asia/Dubai',
  GB: 'Europe/London',
  US: 'America/New_York',
  UY: 'America/Montevideo',
  UZ: 'Asia/Tashkent',
  VU: 'Pacific/Efate',
  VE: 'America/Caracas',
  VN: 'Asia/Ho_Chi_Minh',
  YE: 'Asia/Aden',
  ZM: 'Africa/Lusaka',
  ZW: 'Africa/Harare',
}

/**
 * Resolves an ISO 3166-1 alpha-2 country code to its default IANA timezone
 * (see {@link COUNTRY_TIMEZONES}). Returns `undefined` for an unknown or missing
 * code — callers should fall back to the device's own detected timezone in that case.
 */
export function countryToTimezone(code: string | undefined | null): string | undefined {
  if (!code) return undefined
  return COUNTRY_TIMEZONES[code.toUpperCase()]
}

/**
 * Resolves an ISO 3166-1 alpha-2 code to a localized country name.
 * Uses {@link Intl.DisplayNames} so the UI language (en/ja) drives the label —
 * English names in {@link COUNTRIES} are only a fallback for unknown locales/codes.
 */
export function getCountryName(code: string, locale = 'en'): string {
  try {
    const localized = new Intl.DisplayNames([locale], { type: 'region' }).of(code)
    // Intl returns a string even for unknown codes (e.g. "Unknown Region") — only trust
    // it when it differs from the code and is not the generic unknown-region label.
    if (
      localized &&
      localized !== code &&
      !/^unknown region$/i.test(localized) &&
      !/^不明な地域$/i.test(localized)
    ) {
      return localized
    }
  } catch {
    // fall through
  }
  return COUNTRY_MAP.get(code) ?? code
}
